import locale from "@/helpers/locale";

const getControlDeduction = (data, type) => {
  const {
    taxDetail, //税金
    elseSaleDetail, //売上除外品
    deductDetail //控除額計
  } = data;
  return [
    {
      type: locale("pdf.ticketSale.controlDeduction"),
      name: locale("pdf.ticketSale.key.tax"),
      number: !type ? 16 : 10,
      summary: locale("pdf.ticketSale.value.tax"),
      actualAmount: taxDetail.actualAmount,
      tax: taxDetail.tax,
      amount: taxDetail.amount
    },
    ...elseSaleDetail.map(item => ({
      type: locale("pdf.ticketSale.controlDeduction"),
      name: locale("pdf.ticketSale.key.excludedProducts"),
      number: !type ? 17 : 11,
      summary: item.desc,
      actualAmount: item.actualAmount,
      tax: item.tax,
      amount: item.amount
    })),
    {
      type: locale("pdf.ticketSale.controlDeduction"),
      name: locale("pdf.ticketSale.key.controlDeduction"),
      number: !type ? 18 : 12,
      summary: "（16+17）",
      actualAmount: deductDetail.actualAmount,
      tax: deductDetail.tax,
      amount: deductDetail.amount
    },
  ];
};
const getCouponDetail = data => {
  if (data) {
    return {
      type: locale("pdf.ticketSale.salesRecord"),
      name: locale("pdf.ticketSale.key.hang"),
      number: 10,
      summary: locale("pdf.ticketSale.value.hang"),
      actualAmount: data.actualAmount,
      tax: data.tax,
      amount: data.amount
    };
  }
};
export const getPdfData = (data, type) => {
  const {
    date, cinemaName,
    cashDetail, //現金売
    couponDetail, //掛売
    creditCardDetail, //クレジット売
    goodCouponDetail, //商品券売
    goodCouponFishDetail, //商品券釣り
    mobilePayDetail, //電子マネー売
    saleTotalDetail, //総売上高
    actualSaleTotalDetail, //純売上高
    actualCashDetail, //現金在高（納金）
    actualNumberDetail, //客数
    refundDetail //戻し・返品
  } = data;
  return [
    // 日付
    {
      type: locale("pdf.ticketSale.dailyPayment"),
      name: locale("pdf.ticketSale.dailyPayment"),
      number: 1,
      summary: locale("pdf.ticketSale.saleDate"),
      actualAmount: date,
    },
    // 店铺名
    {
      type: locale("pdf.ticketSale.cinemaNameRow"),
      name: locale("pdf.ticketSale.cinemaNameRow"),
      number: 2,
      summary: locale("pdf.ticketSale.cinemaName"),
      actualAmount: cinemaName,
    },
    // 売上記録
    {
      type: locale("pdf.ticketSale.salesRecord"),
      name: locale("pdf.ticketSale.key.goldSale"),
      number: !type ? 9 : 4,
      summary: locale("pdf.ticketSale.value.goldSale"),
      actualAmount: cashDetail.actualAmount,
      tax: cashDetail.tax,
      amount: cashDetail.amount
    },
    getCouponDetail(couponDetail),
    {
      type: locale("pdf.ticketSale.salesRecord"),
      name: locale("pdf.ticketSale.key.creditSale"),
      number: !type ? 11 : 5,
      summary: locale("pdf.ticketSale.value.creditSale"),
      actualAmount: creditCardDetail.actualAmount,
      tax: creditCardDetail.tax,
      amount: creditCardDetail.amount
    },
    {
      type: locale("pdf.ticketSale.salesRecord"),
      name: locale("pdf.ticketSale.key.commodityCoupons"),
      number: !type ? 12 : 6,
      summary: locale("pdf.ticketSale.value.commodityCoupons"),
      actualAmount: goodCouponDetail.actualAmount,
      tax: goodCouponDetail.tax,
      amount: goodCouponDetail.amount
    },
    {
      type: locale("pdf.ticketSale.salesRecord"),
      name: locale("pdf.ticketSale.key.couponFishing"),
      number: !type ? 13 : 7,
      summary: locale("pdf.ticketSale.value.couponFishing"),
      actualAmount: goodCouponFishDetail.actualAmount,
      tax: goodCouponFishDetail.tax,
      amount: goodCouponFishDetail.amount
    },
    {
      type: locale("pdf.ticketSale.salesRecord"),
      name: locale("pdf.ticketSale.key.electronicSales"),
      number: !type ? 14 : 8,
      summary: locale("pdf.ticketSale.value.electronicSales"),
      actualAmount: mobilePayDetail.actualAmount,
      tax: mobilePayDetail.tax,
      amount: mobilePayDetail.amount
    },
    {
      type: locale("pdf.ticketSale.salesRecord"),
      name: locale("pdf.ticketSale.key.totalSale"),
      number: !type ? 15 : 9,
      summary: !type ? "（9+10+11-12-13+14）" : "（4+5+6+7+8）",
      actualAmount: saleTotalDetail.actualAmount,
      tax: saleTotalDetail.tax,
      amount: saleTotalDetail.amount
    },
    // 控除額
    ...getControlDeduction(data, type),
    // 純売上高
    {
      type: locale("pdf.ticketSale.key.netSalesHigh"),
      name: locale("pdf.ticketSale.key.netSalesHigh"),
      number: !type ? 19 : 13,
      summary: locale("pdf.ticketSale.value.netSalesHigh"),
      actualAmount: actualSaleTotalDetail.actualAmount,
      tax: actualSaleTotalDetail.tax,
      amount: actualSaleTotalDetail.amount
    },
    //現 金 在 高 （ 納 金 ）
    {
      type: locale("pdf.ticketSale.key.cashInHigh(naive)"),
      name: locale("pdf.ticketSale.key.cashInHigh(naive)"),
      number: !type ? 20 : 17,
      summary: !type ? "（9-13）" : "（4-7）",
      actualAmount: actualCashDetail.actualAmount,
      tax: actualCashDetail.tax,
      amount: actualCashDetail.amount
    },
    // 客数
    {
      type: locale("pdf.ticketSale.key.customerNumber"),
      name: locale("pdf.ticketSale.key.customerNumber"),
      number: !type ? 21 : 18,
      summary: locale("pdf.ticketSale.value.customerNumber"),
      actualAmount: actualNumberDetail.actualAmount,
      tax: actualNumberDetail.tax,
      amount: actualNumberDetail.amount
    },
    // 戻し・返品
    {
      type: locale("pdf.ticketSale.key.returnedGoods"),
      name: locale("pdf.ticketSale.key.returnedGoods"),
      number: !type ? 22 : 19,
      summary: locale("pdf.ticketSale.value.returnedGoods"),
      actualAmount: refundDetail.actualAmount,
      tax: refundDetail.tax,
      amount: refundDetail.amount
    }
  ];
};

export const getReportPdfData = (data, type) => {
  const {
    date, cinemaCode,
    couponDetail,
    creditCardDetail,
    goodCouponDetail,
    cashDetail,
    mobilePayDetail,
    saleTotalDetail,
    taxDetail,
    // 特别地方消费税 留空
    elseSaleDetail, //Array
    deductDetail,
    actualSaleTotalDetail,
    actualNumberDetail,
    actualCashDetail

  } = data;
  return [
    // 营业日
    {
      number: locale("pdf.ticketSale.liquidationReport.businessDay"),
      name: locale("pdf.ticketSale.liquidationReport.businessDay"),
      amount: date
    },
    // 店舗コード
    {
      number: locale("pdf.ticketSale.liquidationReport.storeCode"),
      name: locale("pdf.ticketSale.liquidationReport.storeCode"),
      amount: cinemaCode
    },
    // シネ・リーブル池袋
    {
      number: locale("pdf.ticketSale.title"),
      name: locale("pdf.ticketSale.title"),
      amount: ""
    },
    // 掛・自社券等
    {
      number: "01",
      name: locale("pdf.ticketSale.liquidationReport.hanging"),
      amount: !type ? couponDetail.amount : 0
    },
    // クレジット売上
    {
      number: "02",
      name: locale("pdf.ticketSale.liquidationReport.creditSales"),
      amount: creditCardDetail.amount
    },
    // 商品券売上
    {
      number: "03",
      name: locale("pdf.ticketSale.liquidationReport.coupon"),
      amount: goodCouponDetail.amount
    },
    // 現金売上
    {
      number: "04",
      name: locale("pdf.ticketSale.liquidationReport.cash"),
      amount: cashDetail.amount
    },
    // 電子マネー売上
    {
      number: "05",
      name: locale("pdf.ticketSale.liquidationReport.electronicSales"),
      amount: mobilePayDetail.amount
    },
    // 総売上合計
    {
      number: "06",
      name: locale("pdf.ticketSale.liquidationReport.totalSale"),
      amount: saleTotalDetail.amount
    },
    // 消費税
    {
      number: "07",
      name: locale("pdf.ticketSale.saleTax"),
      amount: taxDetail.amount
    },
    // 特別地方消費税
    {
      number: "08",
      name: locale("pdf.ticketSale.liquidationReport.specialTax"),
      amount: ""
    },
    // 売上控除
    ...elseSaleDetail.map(item => ({
      number: "09",
      name: locale("pdf.ticketSale.liquidationReport.disposal"),
      amount: item.amount
    })),
    // 控除合計
    {
      number: "10",
      name: locale("pdf.ticketSale.liquidationReport.controlTotal"),
      amount: deductDetail.amount
    },
    // 純売上
    {
      number: "11",
      name: locale("pdf.ticketSale.liquidationReport.pureSales"),
      amount: actualSaleTotalDetail.amount
    },
    // 客数
    {
      number: "12",
      name: locale("pdf.ticketSale.key.customerNumber"),
      amount: actualNumberDetail.amount
    },
    // 現金在高
    {
      number: "13",
      name: locale("pdf.ticketSale.liquidationReport.cashInHigh"),
      amount: actualCashDetail.amount
    },
  ];
};

